import React, { useEffect, useRef, useState } from "react"
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import config from "../../config"
import validator from "validator"
import { useDispatch, useSelector } from "react-redux"
import { setSavedSearchesModal } from "../actionCreators/boostCommerceAC"
import { memoizedGetParamsString, stripHiddenFilterBlocks } from "./helpers";
import { addSavedSearch } from "../actionCreators/myAccountAC"
import "./SaveSearch.scss"

const SaveSearchModal = () => {
    const textInput = useRef();
    const {showSavedSearchesModal, savedSearchesModalType, savedSearchInputValue, filterTree} = useSelector(state => ({
        showSavedSearchesModal: state.shopifyReducer.showSavedSearchesModal,
        savedSearchesModalType: state.shopifyReducer.savedSearchesModalType,
        savedSearchInputValue: state.shopifyReducer.savedSearchInputValue,
        filterTree: state.appReducer.bc_filter_tree,
    }));
    const [inputValue, setInputValue] = useState("");
    const [inputErrorMessage, setInputErrorMessage] = useState("");
    const dispatch = useDispatch();

    useEffect(() => {
        if (savedSearchesModalType === "save" && textInput.current) {
            textInput.current.focus();
        }
    }, []);

    useEffect(() => {
        setInputValue(savedSearchInputValue);
    }, [savedSearchInputValue]);

    const handleFocus = (event) => {
        event.target.select();
    };

    const closeSaveSearchModal = () => {
        dispatch(setSavedSearchesModal(false, '', ''));
    };

    const saveSearchSubmit = (e) => {
        e.preventDefault();
        const searchParams = new URL(window.location.href).searchParams;
        const {paramsString} = memoizedGetParamsString('', '', searchParams);
        const shopifyUrl = window.location.href.split('?')[1];
        if (inputIsValid()) {
            const cleanFilterTree = filterTree && stripHiddenFilterBlocks(filterTree);
            const urlParams = new URLSearchParams(window.location.search);
            const q = urlParams.get('q');
            const filtersPayload = cleanFilterTree.map((filterBlock) => {
                return {
                    [filterBlock.filterOptionId]: filterBlock.refinements.filter((refinement) => refinement.optionSelected).map((refinement) => refinement.name),
                }
            })
            dispatch(addSavedSearch({shopify_url: shopifyUrl, bc_url: `bc-sf-filter/filter?${paramsString}`, name: inputValue, filters: [{q: q ? [q] : []}, ...filtersPayload]}));
            closeSaveSearchModal();
        }
    };

    const saveSearchEdit = () => {
        window.open(`${config.host_rebag}/my-account/saved-searches`, "_blank");
        closeSaveSearchModal();
    };

    const inputIsValid = () => {
        let isFormValid = false;

        if (validator.isEmpty(inputValue)) {
            setInputErrorMessage("Please enter a search name");
        } else if (!validator.isLength(inputValue, { min: 1, max: 50 })) {
            setInputErrorMessage("Please limit your search name to 50 characters or fewer");
        } else {
            setInputErrorMessage("");
            isFormValid = true;
        }

        return isFormValid;
    };

    if (!showSavedSearchesModal) {
        return null;
    }

    return (
        <Modal
            show={true}
            size='lg'
            centered
            onHide={closeSaveSearchModal}
            className='rbg-popup-generic save-search-modal'
            container={document.getElementById("react-popup-container")}
            backdropClassName="dark-overlay overlay-second-modal"
        >
            <Modal.Header className='rbg-popup-generic__header'>
                <Button
                    className='rbg-popup-generic__close-icon'
                    onClick={closeSaveSearchModal}
                    variant='clean'
                    aria-label='Close'>
                    <span className='icon-close' />
                </Button>
            </Modal.Header>
            <Modal.Body className='rbg-popup-generic__body'>
                <h1 className='save-search-modal__title'>
                    {savedSearchesModalType === "save" && "Save New Search"}
                    {savedSearchesModalType === "edit" && "Save Search Limit"}
                </h1>
                <div className='save-search-modal__title-subline' />
                {savedSearchesModalType === "save" && (
                    <Form noValidate onSubmit={saveSearchSubmit} className='save-search-modal__form'>
                        <Form.Group className='save-search-modal__form-group'>
                            <Form.Label className='save-search-modal__form-label'>Name Your Search</Form.Label>
                            <Form.Control
                                className={`save-search-modal__form-control ${
                                  inputErrorMessage && "save-search-modal__form-control--error"
                                }`}
                                type='text'
                                defaultValue={inputValue}
                                placeholder='Name Your Search'
                                required
                                autoFocus
                                onFocus={handleFocus}
                                ref={textInput}
                                onChange={(e) => setInputValue(e.target.value)}
                            />
                            {inputErrorMessage && <span className='icon-error icon-exclamation' />}
                            <span className='save-search-modal__validation-failed'>{inputErrorMessage}</span>
                        </Form.Group>
                        <Button
                            className='rbg-btn-black save-search-modal__submit'
                            variant='secondary'
                            id='save-search-modal__submit'
                            type='submit'
                        >
                            Save
                        </Button>
                    </Form>
                )}
                {savedSearchesModalType === "edit" && (
                    <div className='save-search-modal__edit'>
                        <p className='save-search-modal__info-text'>
                            Only 10 searches can be saved at one time. Please delete a previously saved search from the
                            My Saved Searches page, and then refresh this page before continuing.
                        </p>
                        <Button
                            className='rbg-btn-black save-search-modal__submit'
                            variant='secondary'
                            onClick={saveSearchEdit}
                        >
                            Go to "My Saved Searches"
                        </Button>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default SaveSearchModal;
